module.exports = __webpack_public_path__ + "static/MIL_1-c3a854c55ada9ceb86e29b04f72da8f0.png";